import { BoletoStatus, ClientStatus, ProdutosStatus, TypeServico } from '@/lib/enums'
import { friendlyNameMaps } from '@/components/form/input/StatusMapper' // ajuste conforme seu path
import { TypeContrato } from '../agreement/utils/enum'

export const produtosLabels: Record<TypeServico, string> = {
  [TypeServico.PIS_COFINS_MONOFASICO_PARA_SN]: 'Simples Nacional',
  [TypeServico.APURACAO_ST]: 'Apuração ST',
  [TypeServico.NEGOCIACAO_DE_PASSIVOS]: 'Negociação de Passivos',
  [TypeServico.PREVIDENCIARIO]: 'Previdenciário',
  [TypeServico.INSS_ACIMA_DO_TETO]: 'INSS Acima do Teto',
  [TypeServico.INSS_MAO_DE_OBRA]: 'INSS M.O',
  [TypeServico.EXCLUSAO_DE_ICMS_E_ST]: 'Exclusão de ICMS e ICMS-ST',
  [TypeServico.ALIQUOTA_ZERO_COMBUSTIVEL]: 'Alíquota Zero - Combustíveis',
  [TypeServico.ALIQUOTA_ZERO]: 'Alíquota Zero',
  [TypeServico.EQUIPARACAO_HOSPITALAR]: 'Equiparação Hospitalar',
  [TypeServico.SUBVENCAO]: 'Subvenção',
  [TypeServico.MVA]: 'MVA',
  [TypeServico.DESPESAS_OPERACIONAIS]: 'Despesas Operacionais',
  [TypeServico.PARCERIA_COMERCIAL]: 'Parceria Comercial',
  [TypeServico.FCVS]: 'FCVS'
  // [TypeServico.INSUMOS]: 'Insumos'
}
export const produtosLabelsTypeContract: Record<TypeContrato, string> = {
  [TypeContrato.PIS_COFINS_MONOFASICO_PARA_SN]: 'PIS/COFINS Monofásico para Simples Nacional',
  [TypeContrato.APURACAO_ST]: 'Apuração ST',
  [TypeContrato.NEGOCIACAO_DE_PASSIVOS]: 'Negociação de Passivos',
  [TypeContrato.PREVIDENCIARIO]: 'Previdenciário',
  [TypeContrato.INSS_MAO_DE_OBRA]: 'INSS sobre mão-de-obra',
  [TypeContrato.EXCLUSAO_DE_ICMS_E_ST]: 'Exclusão de ICMS e ICMS-ST',
  [TypeContrato.ALIQUOTA_ZERO_COMBUSTIVEL]: 'Alíquota Zero - Combustíveis',
  [TypeContrato.FCVS]: 'FCVS',
  // [TypeContrato.INSUMOS]: 'Insumos',
  [TypeContrato.ALIQUOTA_ZERO]: 'Alíquota Zero',
  [TypeContrato.EQUIPARACAO_HOSPITALAR]: 'Equiparação Hospitalar',
  [TypeContrato.INSS_ACIMA_DO_TETO]: 'INSS Acima do Teto',
  [TypeContrato.SUBVENCAO]: 'Subvenção',
  [TypeContrato.PRINCIPAL]: 'Principal',
  [TypeContrato.PESSOA_FISICA]: 'Pessoa Física',
  [TypeContrato.LUCRO_PRESUMIDO]: 'Lucro Presumido',
  [TypeContrato.LUCRO_REAL]: 'Lucro Real',
  [TypeContrato.SIMPLES_NACIONAL]: 'Simples Nacional',
  [TypeContrato.DEFAULT]: 'Padrão',
  [TypeContrato.OPERACIONAL]: 'Operacional',
  [TypeContrato.MVA]: 'MVA'
}
export const statusColorMap: Record<string, string> = {
  // 🟩 Verde – Situação regular ou positiva
  NOVO: 'bg-green-700',
  RESTITUIDO: 'bg-green-600',
  ATIVO: 'bg-green-500',
  PAGO: 'bg-green-400',
  PIX: 'bg-green-300',

  // 🟥 Vermelho – Irregularidade ou inadimplência
  BLOQUEADO: 'bg-red-600',
  PROCURACAO_CANCELADA: 'bg-red-600',
  INADIMPLENTE: 'bg-red-500',
  DADOS_BANCARIOS_INVALIDOS: 'bg-red-400',
  PROTESTADO: 'bg-red-700',
  NEGATIVADO: 'bg-red-700',

  // ⚪️ Cinza – Cancelamento ou expiração
  CANCELADO: 'bg-gray-500',

  // 🟧 Ambar – Situação temporária/suspensa
  PROCURACAO_EXPIRADA: 'bg-amber-500',

  // 🟨 Amarelo – Alerta ou pendência
  DOCUMENTACAO_PENDENTE: 'bg-yellow-500',
  COBRANCA: 'bg-yellow-400',

  // 🔵 Azul – Andamento jurídico ou oficial
  JUDICIAL: 'bg-blue-500',
  DISTRATO: 'bg-blue-400',
  AGUARDANDO_RFB: 'bg-blue-700',
  AVISO_DE_RECEBIMENTO: 'bg-blue-700',

  // 🟣 Roxo – Compensações
  COMPENSADO: 'bg-purple-500',
  COMPENSACAO_SUSPENSA: 'bg-purple-400',

  JURIDICO: 'bg-yellow-600',
  
  INATIVO: 'bg-gray-400',

  // 🟧 Laranja – Situação temporária/suspensa
  PENDENTE: 'bg-orange-500',
  SEM_OPORTUNIDADE: 'bg-orange-700',
  CONTRATO_SUSPENSO: 'bg-orange-600',
  RESTITUIDO_PARCIAL: 'bg-orange-600',
  SUSPENSO: 'bg-orange-500',
  AGUARDANDO_CALCULO: 'bg-orange-400',
  AGUARDANDO_COMPENSACAO: 'bg-orange-400',
  CREDITO_ESGOTADO: 'bg-orange-300',

  // 🔷 Índigo e ciano – Processamento e análise
  RECALCULO: 'bg-indigo-500',
  ANALISE: 'bg-cyan-500',

  // 🦎 Verde azulado – Aguardando ação externa
  SOLICITANDO_AUTORIZACAO: 'bg-teal-500'
} as const satisfies Record<string, string>

const reverseEnumName: Record<number, string> = {}
;[ProdutosStatus, ClientStatus, BoletoStatus].forEach((E: any) => {
  Object.keys(E).forEach(k => {
    const v = E[k]
    if (typeof v === 'number') reverseEnumName[v] = k
  })
})

export function normalizeStatusKey(input: unknown): string {
  if (typeof input === 'number' && reverseEnumName[input]) {
    return reverseEnumName[input].toUpperCase().replace(/\s+|-/g, '_')
  }
  return String(input ?? '')
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toUpperCase()
    .replace(/\s+|-/g, '_')
}

export function getStatusColor(status: unknown): string {
  const key = normalizeStatusKey(status)
  const klass = statusColorMap[key]
  // Debug: comente depois que validar
  if (!klass) {
    // eslint-disable-next-line no-console
    console.warn('[getStatusColor] status sem cor:', { status, key })
  }
  return klass ?? 'bg-gray-500'
}

export const produtosStatusOptions = Object.entries(friendlyNameMaps.produtosStatus).map(([value, label]) => ({
  value: value as ProdutosStatus,
  label
}))

export const formatCurrency = (value: number) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(value)
}
export const campoParaTipoServico = {
  pis_cofins_monofasico_para_sn: TypeServico.PIS_COFINS_MONOFASICO_PARA_SN,
  previdenciario: TypeServico.PREVIDENCIARIO,
  exclusao_icms: TypeServico.EXCLUSAO_DE_ICMS_E_ST,
  subvencao: TypeServico.SUBVENCAO,
  apuracao_st: TypeServico.APURACAO_ST,
  equiparacao_hospitalar: TypeServico.EQUIPARACAO_HOSPITALAR,
  negociacao_de_passivos: TypeServico.NEGOCIACAO_DE_PASSIVOS,
  despesas_operacionais: TypeServico.DESPESAS_OPERACIONAIS,
  fcvs: TypeServico.FCVS
} as const

// define o union das chaves
export type CampoServico = keyof typeof campoParaTipoServico

// força o TS a enxergar que são exatamente essas chaves
export const camposFiltrados: CampoServico[] = Object.keys(campoParaTipoServico) as CampoServico[]
